import './footer.css'
import logo from '../../assets/navbar/Looogo.png'
import Telegram from "../../assets/navbar/icons8-telegram-app (2).svg";
import Instagram from "../../assets/navbar/icons8-instagram (3).svg";
import hhh from '../../assets/navbar/call-center-service (1).png'
import YouTube from "../../assets/navbar/icons8-youtube.svg";
import React from "react";
import Logo from '../../assets/nasha_logo.png'

const Footer = () => {
    return (
        <div className={'footer'}>
            <div className="box">
                <a href="/">
                    <img src={logo} alt=""/>
                </a>
            </div>
            <div className="box">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3000.9216892451777!2d69.20926707514239!3d41.2234770061476!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38ae61ee952be88d%3A0x7011a6082bd19835!2sSof!5e0!3m2!1sru!2s!4v1682154239238!5m2!1sru!2s"
                    width="600" height="450" style={{border: 'none'}} allowFullScreen="" loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"/>
            </div>
            <div className="box">
                <div className="social">
                    <a target={'_blank'} href="https://t.me/sofcafe_bot"><img src={Telegram} width={30}
                                                                              alt=""/></a>
                    <a target={'_blank'} href="https://www.instagram.com/sofcafe.uz/"><img src={Instagram} width={30}
                                                                                           alt=""/></a>
                    {/*<a href="/" target={'_blank'}><img src={YouTube} width={30} alt=""/></a>*/}
                </div>
                <a href="tel:+99855010700">+99855010700</a>
                <a href="tel:1409">1409
                    <img src={hhh} alt=""/></a>
            </div>
            <div className="box">
                <a target='_blank' href="https://www.instagram.com/avacado_technologies/">
                    <div className="data_site">
                        <code>Powered by</code>
                        <img src={Logo} alt="hhh"/>
                        <code>Technologies</code>
                    </div>
                </a>
            </div>
        </div>
    )
}

export default Footer
